import React from 'react';
import { Layout, GetInfo } from '../components';
import '../assets/styles/containers/Packages.sass';

const Packages = () => {
  return (
    <div className="Packages">
      <Layout bannerId={67}>
        <GetInfo id={134}/>
      </Layout>
    </div>
  );
};

export default Packages;
